exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".custom-h2 {\n    margin-top: 0px !important;\n}\n\n.custom-add-button {\n    font-size: 12px;\n    margin-left: -12px;\n}\n\n.filter-icon {\n    position: relative;\n    right: -12px;\n}\n\n.filter-pos {\n    float: right;\n    margin-right: 24px;\n    position: relative;\n    top: 10px;\n}\n\n.action-panel-pos {\n    position: relative;\n    padding-left: 12px;\n    margin-top: 12px;\n}\n\n.refresh-btn {\n    position: absolute;\n    right: 2px;\n    top: 12px;\n    cursor: pointer;\n}\n\n.hide-create {\n    visibility: hidden !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/user/user.component.css
// module id = 838
// module chunks = 0